import { CommunityDiscoverAction } from '../hook/useCommunityDiscover';
import { createContext, Dispatch, ReactNode, useContext } from 'react';

const DiscoverProfileDispatchContext =
  createContext<Dispatch<CommunityDiscoverAction> | null>(null);

type DiscoverProfileDispatchProviderProps = {
  discoverDispatch: Dispatch<CommunityDiscoverAction>;
  children: ReactNode;
};

export const DiscoverProfileDispatchProvider = ({
  discoverDispatch,
  children,
}: DiscoverProfileDispatchProviderProps) => {
  return (
    <DiscoverProfileDispatchContext.Provider value={discoverDispatch}>
      {children}
    </DiscoverProfileDispatchContext.Provider>
  );
};

export const useDiscoverProfileDispatch =
  (): Dispatch<CommunityDiscoverAction> => {
    const dispatch = useContext(DiscoverProfileDispatchContext);
    if (!dispatch) {
      throw Error('DiscoverProfileDispatch is not in the context');
    }
    return dispatch;
  };
